import { render, staticRenderFns } from "./NotificationSettingsEtaGrid.vue?vue&type=template&id=62836f65&"
import script from "./NotificationSettingsEtaGrid.vue?vue&type=script&lang=js&"
export * from "./NotificationSettingsEtaGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports